import React from 'react';
import { Helmet } from "react-helmet"

const MetaData = (props) => {
  const {page} = props

  return (
    <div className="application">
      <Helmet>
        <meta charSet="utf-8" />
        <title>ANFANG - はじまり はじまり -</title>
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@meru_lotte" />
        <meta name="twitter:creator" content="@meru_lotte" />
        <meta property="og:url" content={`https://www.meru-lotte.com/${props.page}`} />
        <meta property="og:title" content="ANFUNG  - はじまり はじまり -" />
        <meta property="og:description" content="ファンタジックなイラストで動画のMVや小説の表紙・挿絵など、あなたの世界観を広げるお手伝いをさせてください。イラストレーターめるろってのホームページ。イラスト制作の依頼・相談承っています。" />
        <meta property="og:image" content="https://www.meru-lotte.com/topimage.jpg" />
      </Helmet>
    </div>
  );
}
export default MetaData;